import React, { useState } from 'react'
import {  Modal, Button } from '@pancakeswap-libs/uikit'
import { RowBetween } from 'components/Row'
import NumericalInput from 'components/NumericalInput'

// import { useActiveWeb3React } from 'hooks'

import { useTranslation } from 'react-i18next'
import { LockText, LockInputBox, WarnTip } from './styleds'


type AddBnbModalProps = {
  onDismiss?: () => void
  translateString: (translationId: number, fallback: string) => string
  bnbBalance: string
  handleAddBnb: (value) => void
  loading: boolean
}

// TODO: Fix UI Kit typings
const defaultOnDismiss = () => null


const AddBnbModal = ({ onDismiss = defaultOnDismiss, translateString, bnbBalance, handleAddBnb, loading }: AddBnbModalProps) => {
  // const { account, chainId } = useActiveWeb3React()
  const [amount, setAmount] = useState('');
  const { t } = useTranslation()
  const handleInput = async value => {
    setAmount(value)
  };

  return (
    <Modal title={translateString(1202, t('Supplementary handling gas fee'))} onDismiss={onDismiss}>
      <RowBetween marginBottom='10px'>
        <LockText>{ t('Supply gas fee') }</LockText>
        <LockText>{ t('Balance') }:{ bnbBalance || '0.000' }DST</LockText>
      </RowBetween>
      <LockInputBox>
       <RowBetween>
          <NumericalInput style={{ flex: 1, display: 'block', marginRight: '5px' }} value={ amount } onUserInput={ handleInput } placeholder={ t('Please enter the quantity') } />
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <LockText style={{ marginRight: '5px' }}>DST</LockText>
          </div>
       </RowBetween>
      </LockInputBox>
       <LockText style={{ marginTop: '12px' }}>{ t('The single trigger gas fee is about') }：0.003 DST</LockText>
       { !amount ? (<Button width="100%" disabled marginTop='20px'>{ t('Please enter the amount of DST') }</Button>) 
       : Number(amount) > Number(bnbBalance) ?
       (<Button width="100%" disabled marginTop='20px'>{ t('Insufficient DST balance') }</Button>) :
       (<Button width="100%"  disabled={ loading } marginTop='20px' onClick={(event) => {
                  event.stopPropagation()
                  handleAddBnb(amount)
              }}>{ loading ? `${ t('Replenish') }...` : t('Replenish') }</Button>)}
       <WarnTip style={{ marginTop: '20px', marginBottom: '0' }}>
       { t('Enter DST fee to realize automatic trigger') }
       </WarnTip>
    </Modal>
  )
}

export default AddBnbModal
